import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Footer({ onNavigateToModule }) {
  const navigate = useNavigate();

  // This function sends the user home AND switches the study tab
  const handleStudyNav = (moduleName) => {
    navigate('/'); // 1. Go to main app route
    if (onNavigateToModule) {
      onNavigateToModule(moduleName); // 2. Tell App.js which tab to open
    }
  };

  return (
    <footer className="border-t pt-16 pb-8 transition-colors duration-300" style={{ background: 'var(--bg-primary)', borderColor: 'var(--border-color)' }}>
      <div className="max-w-[1600px] mx-auto px-6">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 md:gap-10 mb-16">

          {/* App Info & Brand */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-6">
              <div className="w-8 h-8 bg-gradient-to-br from-rose-500 to-rose-700 rounded-lg flex items-center justify-center text-white font-black text-sm shadow-md">
                G
              </div>
              <div className="text-xl font-black tracking-tighter text-slate-900 dark:text-white transition-colors">
                GO4<span className="text-rose-600">NIHONGO</span>
              </div>
            </div>
            <p className="text-sm font-bold text-slate-500 dark:text-slate-400 leading-relaxed max-w-sm transition-colors">
              The ultimate platform for Hindi, Nepali, Bengali, Chinese, Korean, Vietnamese, Thai, Spanish, Italian, German, and French speakers to master the JLPT from N5 to N1.
            </p>
          </div>

          {/* Study Path */}
          <div>
            <h4 className="font-black text-slate-900 dark:text-slate-200 text-[10px] uppercase tracking-widest mb-6 transition-colors">Study Path</h4>
            <nav className="flex flex-col space-y-4 text-sm font-bold text-slate-500 dark:text-slate-400 transition-colors">
              <button onClick={() => handleStudyNav('vocab')} className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit text-left outline-none">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> Vocabulary Lists
              </button>
              <button onClick={() => handleStudyNav('kanji')} className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit text-left outline-none">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> Kanji Master
              </button>
              <button onClick={() => handleStudyNav('grammar')} className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit text-left outline-none">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> Grammar Lab
              </button>
              <button onClick={() => handleStudyNav('quiz')} className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit text-left outline-none">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> JLPT Quizzes
              </button>
            </nav>
          </div>

          {/* Community Links */}
          <div>
            <h4 className="font-black text-slate-900 dark:text-slate-200 text-[10px] uppercase tracking-widest mb-6 transition-colors">Community</h4>
            <nav className="flex flex-col space-y-4 text-sm font-bold text-slate-500 dark:text-slate-400 transition-colors">
              <Link to="/our-story" className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> Our Story
              </Link>
              <Link to="/blog" className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> Blog
              </Link>
              <Link to="/japan-explorer" className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> Japan Explorer
              </Link>
              <Link to="/japan-events" className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> Japan Events
              </Link>
              <Link to="/contact" className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> Contact Us
              </Link>
              <Link to="/study-plans" className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> Pricing
              </Link>
              <Link to="/shop" className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> Shop
              </Link>
            </nav>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="font-black text-slate-900 dark:text-slate-200 text-[10px] uppercase tracking-widest mb-6 transition-colors">Legal</h4>
            <nav className="flex flex-col space-y-4 text-sm font-bold text-slate-500 dark:text-slate-400 transition-colors">
              <Link to="/refund-policy" className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> Refund Policy
              </Link>
              <Link to="/privacy-policy" className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> Privacy Terms
              </Link>
              <Link to="/terms-of-service" className="group hover:text-rose-600 dark:hover:text-rose-400 hover:translate-x-1 cursor-pointer transition-all flex items-center gap-2 w-fit">
                <span className="text-rose-500 opacity-0 -ml-4 transition-all group-hover:opacity-100 group-hover:ml-0">▸</span> Terms of Service
              </Link>
            </nav>
          </div>

          {/* Location/Trust Widget */}
          <div>
            <h4 className="font-black text-slate-900 dark:text-slate-200 text-[10px] uppercase tracking-widest mb-6 transition-colors">Location</h4>
            <div className="bg-gradient-to-b from-slate-50 to-white dark:from-slate-900 dark:to-slate-900/50 p-5 rounded-2xl border border-slate-200/80 dark:border-slate-800 shadow-sm relative overflow-hidden group w-fit transition-colors">
              {/* Decorative background element */}
              <div className="absolute top-0 right-0 w-16 h-16 bg-rose-50 dark:bg-rose-900/20 rounded-bl-full -z-10 group-hover:scale-110 transition-transform duration-500"></div>
              
              <p className="text-[10px] font-black uppercase tracking-widest text-slate-400 dark:text-slate-500 mb-1 transition-colors">Proudly Built in</p>
              <p className="text-sm font-black text-slate-800 dark:text-slate-200 transition-colors">Ageo, Saitama 🇯🇵</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-slate-100 dark:border-slate-800 flex flex-col md:flex-row justify-between items-center gap-6 transition-colors">
          <p className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500 transition-colors">
            © 2026 GO4NIHONGO. All rights reserved.
          </p>
          
          <p className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-400 dark:text-slate-500 transition-colors">
            Made with ❤️ in Japan
          </p>
        </div>
        
      </div>
    </footer>
  );
}